import React from "react";
import "./Sort_by_Modal.css";
import { Modal, Form } from "react-bootstrap";

function Sort_by_Modal({ selectedOption, setSelectedOption, ...props }) {
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <>
      <section className="Sort_by_Modal modal-holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Sort_by_Modal modal-holder"
        >
          <Modal.Header className="common_modal_header">
            <Modal.Title>Sort by</Modal.Title>
            <div className="right_side_close_modal_btn">
              <img
                src="/assets/images/cart/close.png"
                className="close_modal_img"
                onClick={() => {
                  props?.onHide();
                }}
                alt="close"
              />
            </div>
          </Modal.Header>

          <Modal.Body>
            <Form className="form-holder">
              <Form.Group>

                {/* Default */}
                <div className="radio-btn-text-holder">
                  <label
                    className={selectedOption === "" ? "radio_lable_holder active" : "radio_lable_holder"}
                  >
                    <p>Default</p>
                    <Form.Check
                      type="radio"
                      name="sortOptions"
                      value=""
                      checked={selectedOption === ""}
                      onChange={handleOptionChange}
                    />
                  </label>
                </div>

                {/* Price - High to Low */}
                <div className="radio-btn-text-holder">
                  <label
                    className={selectedOption === "DESC" ? "radio_lable_holder active" : "radio_lable_holder"}
                  >
                    <p>Price - High to Low</p>
                    <Form.Check
                      type="radio"
                      name="sortOptions"
                      value="DESC"
                      checked={selectedOption === "DESC"}
                      onChange={handleOptionChange}
                    />
                  </label>
                </div>

                {/* Price - Low to High */}
                <div className="radio-btn-text-holder">
                  <label
                    className={selectedOption === "ASC" ? "radio_lable_holder active" : "radio_lable_holder"}
                  >
                    <p>Price - Low to High</p>
                    <Form.Check
                      type="radio"
                      name="sortOptions"
                      value="ASC"
                      checked={selectedOption === "ASC"}
                      onChange={handleOptionChange}
                    />
                  </label>
                </div>

                {/* Future option - Discount */}
                {/* 
                <div className="radio-btn-text-holder">
                  <label
                    className={selectedOption === "DISCOUNT_DESC" ? "active" : ""}
                  >
                    <p>Discount - High to Low</p>
                    <Form.Check
                      type="radio"
                      name="sortOptions"
                      value="DISCOUNT_DESC"
                      checked={selectedOption === "DISCOUNT_DESC"}
                      onChange={handleOptionChange}
                    />
                  </label>
                </div>
                */}
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default Sort_by_Modal;
